import IndexTableFiltersPanel from '../index-table/filterComponents/IndexTableFiltersPanel';

export default class ProjectsIndexTableFiltersPanel extends IndexTableFiltersPanel {
    onInputChange = (prop, value, forceToChange) => {
        if (prop.meta.slug === 'Type' && this.state.values.Status) {
            delete this.state.values.Status;
            this.state.queries = this.state.queries.filter(x => x.slug !== 'Status');
        }

        super.onInputChange(prop, value, forceToChange);
    }
}